import { Button, Checkbox, Col, Row, Table } from 'antd';
import { ColumnsType, TablePaginationConfig, TableProps } from 'antd/lib/table';
import React, { FC, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { getSkipLimit } from '../../common/helpers';
import { getGames, selectGames } from '../../redux/features/gamesSlice';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { IGame } from '../../types/IGame';

const getColumns = (pathname: string): ColumnsType<IGame> => ([
    {
        title: '#',
        dataIndex: '_id',
        key: '_id',
        render: (id) => <Link to={`${pathname}/${id}`} >{id}</Link>
    },
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
    },
    {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
    },
    {
        title: 'Active',
        dataIndex: 'isActive',
        key: 'isActive',
        render: (value: boolean) => <Checkbox checked={value} />
    },
]);

// TO DO: will be used later
// const getGamesFiltersFromFormValues = (filters: GamesFiltersFields): GamesFiltersModel => ({

// })

const Games: FC = () => {
    const { data: games, isFetching, count } = useAppSelector(selectGames);
    const dispatch = useAppDispatch();


    const [pagination, setPagination] = useState<TablePaginationConfig>({
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
    });

    const handleTableChange: TableProps<IGame>['onChange'] = (newPagination, _filters, _sorter) => {
        setPagination(newPagination);
    }

    // TO DO: will be used later
    //   const [filters, setFilters] = useState<GamesFiltersModel>({});
    //   const handleFilters = (filters: GamesFiltersFields) => {
    //     setPagination(currentpagination => ({ ...currentpagination, current: 1 }));
    //     setFilters(getGamesFiltersFromFormValues(filters));
    //   }

    useEffect(() => {
        setPagination(currentPagination => ({ ...currentPagination, total: count }))
    }, [count]);

    // NOTE: somehow eslint(react-hooks/exhaustive-deps) rule is being triggered if we use direct property access from pagination e.g: pagination.current
    const { current, pageSize } = pagination;
    useEffect(() => {
        dispatch(getGames(getSkipLimit(pageSize, current)));
    }, [dispatch, current, pageSize]);

    const { pathname } = useLocation();

    return (
        <Row>
            <Col span={24}>
                <Row justify="end">
                    <Link to={`${pathname}/create`}>
                        <Button type="primary">Create game</Button>
                    </Link>
                </Row>
            </Col>
            <Col span={24}>
                {/* <RequestFilters setFilters={handleFilters} /> */}
            </Col>
            <Table<IGame>
                className="main-table"
                rowKey="_id"
                loading={isFetching}
                columns={getColumns(pathname)}
                dataSource={games}
                pagination={pagination}
                onChange={handleTableChange}
            />
        </Row>
    )
};

export default Games;
